// src/ManageInventory.js - MODIFICATO

import React, { useState, useEffect } from 'react';
import { db } from './firebase';
import { collection, addDoc, getDocs, deleteDoc, doc, updateDoc, where, query, limit, increment } from 'firebase/firestore';
import { useUser } from './UserContext';
import { logAction } from './loggingService';
import { InventoryModal } from './InventoryModal';
import { BarcodeScannerModal } from './BarcodeScannerModal'; // Importa nuovo componente
import { UpdateQuantityModal } from './UpdateQuantityModal'; // Importa nuovo componente

function ManageInventory() {
    const { userProfile } = useUser();
    const permissionLevel = userProfile?.permissions?.inventory || 'none';
    const canEdit = permissionLevel === 'completo' || permissionLevel === 'semi-completo';
    const canDelete = permissionLevel === 'completo';

    const [inventory, setInventory] = useState([]);
    const [editingItem, setEditingItem] = useState(null);
    
    // Nuovi stati per i modali
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isScannerOpen, setIsScannerOpen] = useState(false);
    const [isUpdateQtyOpen, setIsUpdateQtyOpen] = useState(false);
    const [scannedItem, setScannedItem] = useState(null);

    const fetchData = async () => {
    // --- INIZIO MODIFICA ---
    // Controllo di sicurezza per centerId
    if (!userProfile || !userProfile.centerId) {
        setInventory([]); // Assicura che l'inventario sia vuoto
        return;
    }
    // Usa il nuovo percorso nidificato
    const snapshot = await getDocs(collection(db, 'centers', userProfile.centerId, 'inventory'));
    // --- FINE MODIFICA ---
    const itemList = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setInventory(itemList.sort((a, b) => a.name.localeCompare(b.name)));
};

    useEffect(() => { fetchData(); }, [userProfile]); // <-- MODIFICA QUI

    const handleSaveItem = async (itemData) => {
        const dataToSave = {
            name: itemData.name,
            quantity: Number(itemData.quantity),
            minThreshold: Number(itemData.minThreshold),
            barcode: itemData.barcode || '', // Salva anche il barcode
            centerId: userProfile.centerId,
        };

        if (itemData.id) {
            await updateDoc(doc(db, 'centers', userProfile.centerId, 'inventory', itemData.id), dataToSave); // <-- MODIFICA QUI
            await logAction(userProfile, `ha modificato l'articolo: ${itemData.name}`);
        } else {
            await addDoc(collection(db, 'centers', userProfile.centerId, 'inventory'), dataToSave); // <-- MODIFICA QUI
            await logAction(userProfile, `ha aggiunto l'articolo: ${itemData.name}`);
        }
        setIsModalOpen(false);
        fetchData();
    };

    const handleDeleteItem = async (itemId) => {
    // --- INIZIO MODIFICA ---
    // Aggiungi un controllo di sicurezza
    if (!userProfile || !userProfile.centerId) return;

    const itemToDelete = inventory.find(i => i.id === itemId); // Trova l'oggetto per il log
    if (window.confirm(`Sei sicuro di voler eliminare l'articolo "${itemToDelete?.name || itemId}"?`)) {
        try {
            // Usa il percorso nidificato per eliminare
            await deleteDoc(doc(db, 'centers', userProfile.centerId, 'inventory', itemId));
            if (itemToDelete) {
                await logAction(userProfile, `ha eliminato l'articolo: ${itemToDelete.name}`);
            }
            fetchData(); // Ricarica i dati
        } catch (error) {
            console.error("Errore eliminazione articolo:", error);
        }
    }
    // --- FINE MODIFICA ---
};
    
    // Logica di gestione dopo la scansione
    const handleScanResult = async (barcode) => {
        setIsScannerOpen(false); // Chiudi lo scanner
        
        // Cerca l'articolo nel database
        if (!userProfile || !userProfile.centerId) {
        console.error("Scanner: centerId non disponibile.");
        return;
    }
    const q = query(collection(db, 'centers', userProfile.centerId, 'inventory'), where("barcode", "==", barcode), limit(1));
    // --- FINE MODIFICA ---
        const snapshot = await getDocs(q);

        if (snapshot.empty) {
            // Articolo non trovato: apri il modale di creazione con il codice pre-compilato
            setEditingItem({ barcode: barcode }); // Passa un oggetto con solo il barcode
            setIsModalOpen(true);
        } else {
            // Articolo trovato: apri il modale di aggiornamento quantità
            const foundItem = { id: snapshot.docs[0].id, ...snapshot.docs[0].data() };
            setScannedItem(foundItem);
            setIsUpdateQtyOpen(true);
        }
    };
    
    // Funzione per aggiornare la quantità (+1 o -1)
    const handleUpdateQuantity = async (item, amount) => {
        const itemRef = doc(db, 'centers', userProfile.centerId, 'inventory', item.id); // <-- MODIFICA QUI
        await updateDoc(itemRef, {
            quantity: increment(amount)
        });
        // Aggiorna la vista locale per un feedback immediato
        setScannedItem(prev => ({ ...prev, quantity: prev.quantity + amount }));
        fetchData(); // Ricarica i dati per coerenza
    };

    const handleEditClick = (item) => {
        setEditingItem(item);
        setIsModalOpen(true);
    };

    const handleNewClick = () => {
        setEditingItem(null);
        setIsModalOpen(true);
    };

    return (
        <div style={{ maxWidth: '1300px', margin: '20px auto', padding: '0 20px' }}>
            {isModalOpen && <InventoryModal itemData={editingItem} onSave={handleSaveItem} onClose={() => setIsModalOpen(false)} />}
            {isScannerOpen && <BarcodeScannerModal onScan={handleScanResult} onClose={() => setIsScannerOpen(false)} />}
            {isUpdateQtyOpen && <UpdateQuantityModal item={scannedItem} onUpdate={handleUpdateQuantity} onClose={() => setIsUpdateQtyOpen(false)} />}
            
            <div className="management-container">
                <div className="management-header">
                    <h4>Gestione Inventario</h4>
                    {canEdit && (
                        <div style={{display: 'flex', gap: '10px'}}>
                            {/* Nuovo pulsante per la scansione */}
                            <button onClick={() => setIsScannerOpen(true)} className="info-button">📷 Scansiona</button>
                            <button onClick={handleNewClick} className="add-new-button">+ Aggiungi Articolo</button>
                        </div>
                    )}
                </div>
                <div className="management-list">
                    {inventory.map(item => (
                        <div key={item.id} className="management-card">
                            <div className="list-item-content">
                                <span className="list-item-main-text">{item.name}</span>
                                <span className={`list-item-sub-text ${item.quantity <= item.minThreshold ? 'text-danger' : ''}`}>
                                    Quantità: {item.quantity} (Soglia: {item.minThreshold})
                                </span>
                                {item.barcode && <span className="list-item-sub-text">Codice: {item.barcode}</span>}
                            </div>
                            <div className="list-item-actions">
                                {canEdit && <button onClick={() => handleEditClick(item)} className="info-button">Modifica</button>}
                                {canDelete && <button onClick={() => handleDeleteItem(item.id)} className="delete-button">Elimina</button>}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default ManageInventory;
